import { baseQuery, exceptionQuery } from "../baseQuery";
import { GetFilesRequest, GetFilesResponse, OpenFileRequest } from "./models";

const getFiles = ({ client_id }: GetFilesRequest) =>
  baseQuery.post<GetFilesResponse>("/files", { client_id });

const openFile = ({ path }: OpenFileRequest) =>
  exceptionQuery.get<any>(`${path}`, { responseType: "blob" });

export const FilesService = {
  getFiles,
  openFile,
};
